import { CommonModule } from '@angular/common';
import { Component, Input, forwardRef } from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-duration',
    templateUrl: './duration.component.html',
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DurationComponent),
            multi: true,
        },
    ]
})
export class DurationComponent {
    @Input() required = false;
    @Input() name!: string;
    @Input() props!: any;
    @Input() id!: string;
    @Input() formControl!: FormControl;
    @Input() yearOrder!: string;
    @Input() startYear!: string;
    @Input() endYear!: string;

    private onChange: (value: string | number) => void = () => { };
    private onTouched: () => void = () => { };

    duration: any = {
        month: null,
        year: null,
    };

    // ATTRIBUTES (with default values if not set)
    yearOrderFlag: boolean = (this.yearOrder && this.yearOrder === 'asc') ? false : true; // year order: 'asc' or 'desc', default: desc

    // INIT YEARS, MONTHS AND DAYS NUMBER
    selects: any = {
        months: [
            { key: 0, text: "Less than a month" },
            { key: 1, text: "1 Month" },
            { key: 2, text: "2 Months" },
            { key: 3, text: "3 Months" },
            { key: 4, text: "4 Months" },
            { key: 5, text: "5 Months" },
            { key: 6, text: "6 Months" },
            { key: 7, text: "7 Months" },
            { key: 8, text: "8 Months" },
            { key: 9, text: "9 Months" },
            { key: 10, text: "10 Months" },
            { key: 11, text: "11 Months" }
        ],
        years: [
            { key: 0, text: "0 Years" },
            { key: 1, text: "1 Year" },
            { key: 2, text: "2 Years" },
            { key: 3, text: "3 Years" },
            { key: 4, text: "4 Years" },
            { key: 5, text: "5 Years" },
            { key: 6, text: "6 Years" },
            { key: 7, text: "7 Years" },
            { key: 8, text: "8 Years" },
            { key: 9, text: "9 Years" },
            { key: 10, text: "10 Years +" }
        ]
    };

    durationForm = new FormGroup({
        year: new FormControl(''),
        month: new FormControl(''),
    });


    identify(index: number, item: any) {
        return item.name;
    }

    writeValue(value: any): void {
        if (value) {
            if (parseInt(value)) {
                this.duration.month = this.selects.months[ parseInt(value) % 12 ];
                this.duration.year = this.selects.years[ Math.floor((parseInt(value) / 12)) ];

                this.durationForm.controls.year.setValue(this.duration.year.key);
                this.durationForm.controls.month.setValue(this.duration.month.key);
            }
        }
    }

    registerOnChange(fn: (value: string | number) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    onInputChange(): void {
        const duration: any = this.durationForm.value;

        const yearIsValid = duration.year !== "";
        const monthIsValid = duration.month !== "";

        const errors:any = [];

        // IF REQUIRED
        if (this.props.required) {

            // VALIDATION RULES
            const durationIsValid = yearIsValid && monthIsValid;

            // SET INPUT VALIDITY
            !(yearIsValid || monthIsValid) && errors.push('required');
            !(yearIsValid) && errors.push('yearRequired');
            !(monthIsValid) && errors.push('monthRequired');
            !(durationIsValid) && errors.push('durationInvalid');

            // UPDATE NG MODEL
            if (durationIsValid) {
                const result = (duration.year * 12) + duration.month;
                this.onChange(result);
            }
        }

        // IF NOT REQUIRED (still need the 2 values filled to update the model)
        else if (yearIsValid && monthIsValid) {
            errors.push('required')
            const result = (duration.year * 12) + duration.month;
            this.onChange(result);
        }
        else if (!this.props.required && !yearIsValid && !monthIsValid) {
            errors.push('required')
            this.onChange(0);
        }

        if (errors.length > 0) {
            this.formControl.setErrors(errors);
        }
    }
}
